var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhotoBridgeLogoWhiteOnRed = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "36px",
  height: "18px",
  viewBox: "0 0 36 18",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-4",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "sc1",
  transform: "translate(-104.000000, -91.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "screen",
  transform: "translate(20.000000, 69.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Header",
  transform: "translate(0.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Logo",
  transform: "translate(84.000000, 22.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  x: 0,
  y: 0,
  width: 36,
  height: 18
}), /*#__PURE__*/React.createElement("path", {
  d: "M18,3.6 C25.9529004,3.6 32.4,10.0470996 32.4,18 L32.4,18 L3.6,18 C3.6,10.0470996 10.0470996,3.6 18,3.6 Z",
  id: "Combined-Shape",
  fill: "#CC0000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18,10.8 C21.9764502,10.8 25.2,14.0235498 25.2,18 L25.2,18 L10.8,18 C10.8,14.0235498 14.0235498,10.8 18,10.8 Z",
  id: "Combined-Shape",
  fill: "#FFFFFF"
}))))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhotoBridgeLogoWhiteOnRed);
export default ForwardRef;